import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import DeviceDrawer from "@/components/DeviceDrawer";
import { useLang } from "@/i18n";
import api, { apiError } from "@/lib/api";

export default function DeviceScan() {
  const { ident } = useParams();
  const { lang } = useLang();
  const navigate = useNavigate();
  const [device, setDevice] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/devices/${encodeURIComponent(ident)}`);
      setDevice(r.data);
    } catch (err) {
      toast.error(apiError(err));
      setDevice(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [ident]);

  if (loading) {
    return <div className="min-h-screen bg-white flex items-center justify-center text-gray-600"><Loader2 className="w-5 h-5 animate-spin mr-2" /> …</div>;
  }
  if (!device) {
    return <div className="min-h-screen bg-white flex items-center justify-center text-gray-600" data-testid="scan-notfound">{lang === "de" ? "Gerät nicht gefunden" : "Device not found"}</div>;
  }
  return (
    <div className="min-h-screen bg-white">
      <DeviceDrawer device={device} lang={lang} onClose={() => navigate("/inventory")} onChanged={load} />
    </div>
  );
}
